// frontend/src/components/OwnerDashboard/TriagePanel.js
// Replaces the row of coloured alert pills. Equal-height tiles reflowing 2-up / 1-up,
// each carrying its own plates and action — no empty space beside a taller neighbour.

import { useState } from 'react';
import { IconWarn, IconChevron } from '../icons/Icons';

const VISIBLE_PLATES = 3;

export default function TriagePanel({ health, onOpenGroup, onAction, onSelectVehicle }) {
  if (!health.groups.length) {
    return (
      <section className="flex-1 min-w-0 basis-[480px] rounded-2xl border border-[#241F1B] bg-gradient-to-b from-[#17140F] to-[#131110] p-6">
        <p className="text-[13px] text-[#74A98D]">Aucune échéance en retard. La flotte est à jour.</p>
      </section>
    );
  }

  return (
    <section className="flex-1 min-w-0 basis-[480px] rounded-2xl border border-[#3A2622] bg-gradient-to-b from-[#1A1210] to-[#141110] overflow-hidden">
      <header className="flex flex-wrap items-center gap-2.5 px-[18px] py-[15px] border-b border-[#2B2724]">
        <span className="w-[26px] h-[26px] rounded-lg bg-[rgba(226,87,75,.14)] text-[#E2574B] flex items-center justify-center shrink-0">
          <IconWarn className="w-[15px] h-[15px]" />
        </span>
        <div className="flex-1 min-w-0 basis-[190px]">
          <h2 className="font-['Space_Grotesk',sans-serif] text-[14.5px] font-semibold tracking-[-.01em] text-[#F4F1EA]">
            À traiter en priorité
          </h2>
          <p className="text-[11.5px] text-[#8F877B] mt-0.5">{health.triageSub}</p>
        </div>
        <button
          onClick={() => onAction?.('all')}
          className="h-[29px] px-3 rounded-lg border border-[#3A2622] bg-[rgba(226,87,75,.10)] hover:bg-[rgba(226,87,75,.18)]
                     text-[11.5px] font-semibold text-[#E88378] hover:text-[#F4F1EA] transition-colors"
        >
          Tout régulariser
        </button>
      </header>

      <div className="grid gap-px bg-[#221E1B] [grid-template-columns:repeat(auto-fit,minmax(228px,1fr))]">
        {health.groups.map((g) => (
          <Tile key={g.key} group={g} onOpenGroup={onOpenGroup}
                onAction={onAction} onSelectVehicle={onSelectVehicle} />
        ))}
      </div>
    </section>
  );
}

function Tile({ group, onOpenGroup, onAction, onSelectVehicle }) {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? group.vehicles : group.vehicles.slice(0, VISIBLE_PLATES);
  const hidden = group.vehicles.length - shown.length;

  return (
    <article className="bg-[#151211] hover:bg-[#1A1613] transition-colors px-4 pt-3.5 pb-[15px] flex flex-col gap-2.5">
      <div className="flex items-start gap-2.5">
        <button
          onClick={() => onOpenGroup?.(group)}
          className="font-['Space_Grotesk',sans-serif] text-[26px] font-semibold leading-[.9] tabular-nums"
          style={{ color: group.color }}
        >
          {group.count}
        </button>
        <div className="flex-1 min-w-0">
          <h3 className="text-[13px] font-medium text-[#F4F1EA] leading-[1.25]">{group.title}</h3>
          <p className="text-[11px] text-[#7C7468] mt-[3px] leading-[1.35]">{group.sub}</p>
        </div>
        <span className="text-[9px] font-semibold uppercase tracking-[.1em] px-[7px] py-[3px] rounded-[5px] whitespace-nowrap"
              style={{ color: group.color, background: group.tint }}>
          {group.level}
        </span>
      </div>

      <div className="flex flex-wrap gap-[5px]">
        {shown.map((v) => (
          <button
            key={v._id}
            onClick={() => onSelectVehicle?.(v)}
            className="font-['Space_Grotesk',sans-serif] text-[11px] font-medium tracking-[.02em] px-[7px] py-[3px]
                       rounded-md border border-[#2B2724] hover:border-[#4E4740] bg-[#100F0D]
                       text-[#A79E90] hover:text-[#F4F1EA] whitespace-nowrap transition-colors"
          >
            {v.plateNumber}
          </button>
        ))}
        {(hidden > 0 || expanded) && (
          <button
            onClick={() => setExpanded((e) => !e)}
            className="text-[11px] px-[7px] py-[3px] rounded-md border border-dashed border-[#2B2724] hover:border-[#4E4740]
                       text-[#7C7468] hover:text-[#F4F1EA] whitespace-nowrap transition-colors"
          >
            {hidden > 0 ? `+${hidden}` : 'réduire'}
          </button>
        )}
      </div>

      <button
        onClick={() => onAction?.(group.key, group)}
        className="mt-auto h-[29px] rounded-lg border border-[#2B2724] hover:border-[#4E4740] bg-[#1B1815] hover:bg-[#241F1B]
                   text-[11.5px] font-semibold text-[#C9C3B6] hover:text-[#F4F1EA] flex items-center justify-center gap-1.5 transition-colors"
      >
        {group.cta}
        <IconChevron className="w-[13px] h-[13px]" />
      </button>
    </article>
  );
}
